import { StyleSheet } from 'aphrodite/no-important';

export default StyleSheet.create({
  dFlex: {
    display: 'flex',
  },
  fluid: {
    width: '100%',
  },
  flexOut: {
    flex: 1,
  },
});

export const directionStyles = StyleSheet;
